import {EvaluatedCellError} from 'notebook/tables/excess/Evaluator';
import {
  AgentMismatchError,
  BypassedValidationRuleWarning,
  Info,
  sortErrors,
  ValidationRuleError,
  Warning,
} from 'notebook/tables/excess/Util';
import {BaseCellError, TriangleState} from 'notebook/tables/TableConstants';

export function computeErrorState(error: EvaluatedCellError | undefined): TriangleState {
  if (error == null) {
    return TriangleState.VALID_NO_TRIANGLE;
  }

  const sorted = sortErrors(error);
  const highest: BaseCellError = Array.isArray(sorted) ? sorted[0] : sorted;
  return highest.errorState ?? TRIANGLE_STATE_BY_ERROR_TYPE[highest.type] ?? TriangleState.ILLEGAL;
}

const TRIANGLE_STATE_BY_ERROR_TYPE: Record<string, TriangleState> = {
  [Info.type]: TriangleState.VALID_WITH_TRIANGLE,
  [Warning.type]: TriangleState.WARNING,
  [AgentMismatchError.type]: TriangleState.WARNING,
  [BypassedValidationRuleWarning.type]: TriangleState.WARNING,
  [ValidationRuleError.type]: TriangleState.ILLEGAL,
};
